import { utils } from '@hotjar/tracking';

import { EVENT_TRIGGERED_ON } from '../constants-types/TrackEventTriggers';
import type { TrackableSite } from '../constants-types/ExternalDependencyTypes';

type TriggeredOnSate = { state_event_was_triggered_on: string };

export function getEventTriggeredOnState(): TriggeredOnSate {
  return { state_event_was_triggered_on: EVENT_TRIGGERED_ON.REPORT };
}

export function getTrackGroupDataAndTriggeredOnState(currentSite: TrackableSite): {
  groupData: ReturnType<typeof utils.extractSiteGroupingProps>;
  data: TriggeredOnSate;
} {
  return {
    groupData: utils.extractSiteGroupingProps(currentSite),
    data: {
      ...getEventTriggeredOnState(),
    },
  };
}
